<div class="container-fluid question-divider" [id]="question?.code">
    <div class="question-body">
        <div class="question-text">{{question.questionText}}</div>
        <div class="question-form">
            <div *ngIf="question.answerType === QuestionAnswerType.YES_NO">
                <jhi-boolean-input [(value)]="answerValue" [valueText]="question.answerText"
                    (action)="answerBaseQuestion()" [question]="question" [summaryMode]="summaryMode"
                    [question]="question">
                </jhi-boolean-input>
                <jhi-picklist-input *ngIf="question.picklistQuestionMeta != null" [name]="question.code"
                    [enableChangeButton]="false" [options]="question.picklistQuestionMeta.picklistItems"
                    (action)="handleDisclosurePickListEvent($event)" [(value)]="picklistAnswer"
                    [summaryMode]="summaryMode" [question]="question">
                </jhi-picklist-input>
            </div>
            <div *ngIf="question.answerType === QuestionAnswerType.ENTER_DETAILS">
                <jhi-picklist-input *ngIf="question.picklistQuestionMeta != null" [name]="question.code"
                    [enableChangeButton]="false" [options]="question.picklistQuestionMeta.picklistItems"
                    (action)="handleDisclosurePickListEvent($event)" [(value)]="picklistAnswer"
                    [summaryMode]="summaryMode" [question]="question">
                </jhi-picklist-input>
            </div>
            <div *ngIf="question.answerType === QuestionAnswerType.PICKLIST">
                <jhi-picklist-input [name]="question.code" [options]="question.picklistQuestionMeta.picklistItems"
                    (action)="handleDisclosurePickListEvent($event)" [enableChangeButton]="false"
                    [(value)]="picklistAnswer" [bqAnswer]="answerValue"
                    [showNoneOfTheAbove]=question.picklistQuestionMeta.pickListNoneOfTheAboveVisible
                    [summaryMode]="summaryMode" [question]="question">
                </jhi-picklist-input>
            </div>
        </div>
    </div>

    <div class="row mt-2" *ngIf="!summaryMode
            && question.picklistQuestionMeta && question.picklistQuestionMeta.picklistSearchEnabled && answerValue.length > 0
            && picklistAnswer != null && picklistAnswer.trim().length > 0">
        <div>
            <div class="question-text">{{question.picklistQuestionMeta.picklistSearchText}}</div>
            <div class="question-form">
                <div *ngIf="!question.searchingPicklistDisclosure">
                    <a (click)="question.searchingPicklistDisclosure = true;">
                        Add Another Condition
                    </a>
                </div>
                <div *ngIf="question.searchingPicklistDisclosure">
                    <span *ngIf="question.searchingPicklistDisclosure">
                        <a (click)="question.searchingPicklistDisclosure = false;">
                            Cancel
                        </a>
                    </span>
                    <jhi-disclosure-search-input (action)="handleDisclosureSearchEvent($event)" [question]="question"
                        [searchIdentifier]="searchIdentifier">
                    </jhi-disclosure-search-input>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2 ais-reflexive-question" *ngIf="question.disclosureSource"
        [ngSwitch]="question.disclosureSource">
        <div class="w-100" *ngSwitchCase="DisclosureSource.SEARCH">
            <div *ngIf="!summaryMode">
                <div class="offset-7"></div>
                <div class="question-form">
                    <jhi-disclosure-search-input (action)="handleDisclosureSearchEvent($event)" [question]="question"
                        [searchIdentifier]="searchIdentifier">
                    </jhi-disclosure-search-input>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let disclosure of filteredDisclosures; let idx = index;">
        <div class="w-100">
            <div>
                <jhi-questions-reflexive *ngIf="disclosure.questions" [showDisclosureName]="true"
                    [disclosureIdentifier]="interviewDisclosureIdentifier(disclosure.aliasName)"
                    [caseDetails]="caseDetails" [(disclosure)]="disclosure" [summaryMode]="summaryMode"
                    [disclosureSource]="question.disclosureSource" (onRemove)="handleDisclosureRemove($event)"
                    (onRemoveTriggeredDisclosure)="removeTriggeredDisclosures($event)"
                    (onUpdate)="handleDisclosureUpdate($event)" [category]="question.category.code">
                </jhi-questions-reflexive>
                <jhi-question-unknown *ngIf="!disclosure.defaultCondition && disclosure.unknown"
                    [showDisclosureName]="true"
                    [disclosureIdentifier]="interviewDisclosureIdentifier(disclosure.aliasName)"
                    [(disclosure)]="disclosure" [summaryMode]="summaryMode"
                    [disclosureSource]="this.question.disclosureSource" (onRemove)="handleDisclosureRemove($event)">
                </jhi-question-unknown>
                <!-- <jhi-question-non-interactive *ngIf="!disclosure.unknown && !disclosure.questions"
                    [showDisclosureName]="true"
                    [disclosureIdentifier]="interviewDisclosureIdentifier(disclosure.aliasName)"
                    [(disclosure)]="filteredDisclosures[idx]" [summaryMode]="summaryMode"
                    [disclosureSource]="question.disclosureSource" (onRemove)="handleDisclosureRemove($event)">
                </jhi-question-non-interactive> -->
                <jhi-physician-capture #physicianRef *ngIf="disclosure.physicianDetailsRequired" [name]="disclosure.aliasName"
                    [primary]="false" [disclosure]="disclosure"
                    [(disclosurePhysicians)]="disclosurePhysicians" [summaryMode]="summaryMode"
                    [lifeIdentifier]="questionIdentifier" [countries]="countries"
                    [disclosureIdentifier]="interviewDisclosureIdentifier(disclosure.aliasName)"
                    [(physicians)]="physicians">
                </jhi-physician-capture>
            </div>
        </div>
    </div>
</div>